import { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  PlayerPageMessage,
  playerPagesActions,
} from 'src/dashboard/state/player-pages/player-pages-actions';

import './player-page-wrapper.css';

type VideoDetailsPageUrlBase = '/videos';
type VideoDetilsPageUrlParams = string;
type VideoDetailsPagePath = 'details';
type VideoDetailsPageUrl =
  `${VideoDetailsPageUrlBase}/${VideoDetilsPageUrlParams}/${VideoDetailsPagePath}`;

type VideoAnalyticsPageUrlBase = '/videos';
type VideoAnalyticsPageUrlParams = string;
type VideoAnalyticsPagePath = 'analytics';
type VideoAnalyticsPageUrl =
  `${VideoAnalyticsPageUrlBase}/${VideoAnalyticsPageUrlParams}/${VideoAnalyticsPagePath}`;

type AcceptedPageUrls = VideoDetailsPageUrl | VideoAnalyticsPageUrl;

type PlayerPageWrapperOwnProps = {
  title: string;
  page: AcceptedPageUrls;
};

type PlayerPageWrapperProps = PlayerPageWrapperOwnProps & {
  receiveMessage: typeof playerPagesActions.receiveMessage;
};

const mapDispatchToProps = {
  receiveMessage: playerPagesActions.receiveMessage,
};

const PlayerPageWrapperComponent = ({
  title,
  page,
  receiveMessage,
}: PlayerPageWrapperProps) => {
  const pageSrc = `${process.env.REACT_APP_NEXTJS_IFRAME_HOST}${page}`;

  useEffect(() => {
    const handlePlayerMessages = (e: MessageEvent<PlayerPageMessage>) => {
      if (e.origin !== process.env.REACT_APP_NEXTJS_IFRAME_HOST) {
        return;
      }

      receiveMessage(e.data);
    };

    window.addEventListener('message', handlePlayerMessages);

    return () => {
      window.removeEventListener('message', handlePlayerMessages);
    };
  });

  return (
    <iframe
      title={title}
      src={pageSrc}
      allow="clipboard-write;fullscreen"
      className="player-page-wrapper__frame"
    />
  );
};

export const PlayerPageWrapper = connect(
  null,
  mapDispatchToProps
)(PlayerPageWrapperComponent);
